import type { ReactNode } from "react";
import { type ExternalToast, toast as sonnerToast } from "sonner";

export const toast = {
	success: (message: ReactNode, options?: ExternalToast) => {
		return sonnerToast.success(message, {
			...options,
		});
	},

	error: (message: ReactNode, options?: ExternalToast) => {
		return sonnerToast.error(message, {
			...options,
			duration: 5000,
		});
	},

	info: (message: ReactNode, options?: ExternalToast) => {
		return sonnerToast.info(message, options);
	},

	warning: (message: ReactNode, options?: ExternalToast) => {
		return sonnerToast.warning(message, options);
	},

	promise: <T,>(
		promise: Promise<T>,
		options: {
			loading: ReactNode;
			success: ReactNode | ((data: T) => ReactNode);
			error: ReactNode | ((err: unknown) => ReactNode);
		},
	) => {
		return sonnerToast.promise(promise, options);
	},

	saved: (item: string = "Changes") =>
		toast.success(<span>{item} saved successfully.</span>),
	updated: (item: string = "Item") =>
		toast.success(<span>{item} updated successfully.</span>),
	created: (item: string = "Item") =>
		toast.success(<span>{item} created successfully.</span>),
	deleted: (item: string = "Item") =>
		toast.success(<span>{item} deleted successfully.</span>),
	resent: (item: string = "Invite") =>
		toast.success(<span>{item} resent successfully.</span>),
};
